export const jodit = {
  en: {
    'jodit.Bold': 'Bold',
    'jodit.Italic': 'Italic',
    'jodit.Underline': 'Underline',
    'jodit.Strike through': 'Strike through',
    'jodit.Clear formatting': 'Clear formatting',
    'jodit.Clear Formatting': 'Clear Formatting',
    'jodit.Insert link': 'Insert link',
    'jodit.Unlink': 'Unlink',
    'jodit.Insert Unordered List': 'Insert Unordered List',
    'jodit.Default': 'Default',
    'jodit.Circle': 'Circle',
    'jodit.Square': 'Square',
    'jodit.Dot': 'Dot',
    'jodit.Insert Ordered List': 'Insert Ordered List',
    'jodit.Lower Alpha': 'Lower Alpha',
    'jodit.Lower Greek': 'Lower Greek',
    'jodit.Lower Roman': 'Lower Roman',
    'jodit.Upper Alpha': 'Upper Alpha',
    'jodit.Upper Roman': 'Upper Roman',
    'jodit.Insert format block': 'Insert format block',
    'jodit.Paragraph': 'Paragraph',
    'jodit.Heading 1': 'Heading 1',
    'jodit.Heading 2': 'Heading 2',
    'jodit.Heading 3': 'Heading 3',
    'jodit.Heading 4': 'Heading 4',
    'jodit.Quote': 'Quote',
    'jodit.Code': 'Code',
    'jodit.Undo': 'Undo',
    'jodit.Redo': 'Redo',
    'jodit.Type something': 'Type something',
    'jodit.Insert image': 'Insert image',
    'jodit.Insert table': 'Insert table',
    'jodit.Source code': 'Source code',
    'jodit.Fullsize': 'Fullsize',
    'jodit.Shrink': 'Shrink',
    'jodit.Select all': 'Select all',
  },
  uk: {
    'jodit.Bold': 'Жирний',
    'jodit.Italic': 'Курсив',
    'jodit.Underline': 'Підкреслений',
    'jodit.Strike through': 'Закреслений',
    'jodit.Clear formatting': 'Очистити форматування',
    'jodit.Clear Formatting': 'Очистити форматування',
    'jodit.Insert link': 'Вставити посилання',
    'jodit.Unlink': 'Видалити посилання',
    'jodit.Insert Unordered List': 'Вставити маркований список',
    'jodit.Default': 'За замовчуванням',
    'jodit.Circle': 'Коло',
    'jodit.Square': 'Квадрат',
    'jodit.Dot': 'Точка',
    'jodit.Insert Ordered List': 'Вставити нумерований список',
    'jodit.Lower Alpha': 'Малі латинські (a, b, c)',
    'jodit.Lower Greek': 'Малі грецькі (α, β, γ)',
    'jodit.Lower Roman': 'Малі римські (i, ii, iii)',
    'jodit.Upper Alpha': 'Великі латинські (A, B, C)',
    'jodit.Upper Roman': 'Великі римські (I, II, III)',
    'jodit.Insert format block': 'Вставити блок форматування',
    'jodit.Paragraph': 'Абзац',
    'jodit.Heading 1': 'Заголовок 1',
    'jodit.Heading 2': 'Заголовок 2',
    'jodit.Heading 3': 'Заголовок 3',
    'jodit.Heading 4': 'Заголовок 4',
    'jodit.Quote': 'Цитата',
    'jodit.Code': 'Код',
    'jodit.Undo': 'Скасувати',
    'jodit.Redo': 'Повторити',
    'jodit.Type something': 'Введіть текст',
    'jodit.Insert image': 'Вставити зображення',
    'jodit.Insert table': 'Вставити таблицю',
    'jodit.Source code': 'Вихідний код',
    'jodit.Fullsize': 'На весь екран',
    'jodit.Shrink': 'Зменшити',
    'jodit.Select all': 'Вибрати все',
  },
};
